

















































































































































































































































































































































































































































































































































































































































import {computed, defineComponent, ref, useContext, useFetch, watch} from '@nuxtjs/composition-api';
import type {PropType} from '@nuxtjs/composition-api';
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {
  SfButton,
  SfLoader,
  SfLink,
  SfCheckbox,
} from '@storefront-ui/vue';
import Input from '~/components/Palmers/Input/Input.vue';
import Checkbox from '~/components/Palmers/Forms/Checkbox.vue';
import {required, email} from 'vee-validate/dist/rules';
import {customerPasswordRegExp} from '~/modules/customer/helpers/passwordValidation';
import {customerInputRegExp, invalidTextMsg} from '~/modules/customer/helpers/inputTextValidation';
import {FormName, RegisterFormFieldsClub} from '~/components/Palmers/Forms/Register/types';
import AddressNew from "~/pages/_Palmers/MyAccount/AddressesDetails/AddressNew.vue";
import addressGetter from "~/modules/customer/getters/addressGetter";
import {Country} from "~/modules/GraphQL/types";
import {useCountrySearch} from "~/composables";
import Select from "~/components/Palmers/BaseComponents/Select/Select.vue";
import {useNotifications, useUrl} from "~/composables/Palmers";
import createCustomerSF from "~/customQueries/mutation/createCustomerSF.gql";
import LoaderFrame from "~/components/Palmers/BaseComponents/Loaders/LoaderFrame.vue";
extend('email', {
  ...email,
  message: 'Invalid email',
});

extend('required', {
  ...required,
  message: 'This field is required',
});

extend('requiredcheckbox', {
  validate: value => !!value,
  message: 'This field is required\''
});

extend('password', {
  params: ['target'],
  validate: (value: string, {target}: Record<string, any>) => {
    if (!customerPasswordRegExp.test(value)) {
      return 'The password must be at least 8 characters long and must contain at least: 1 uppercase or lowercase letter, 1 number, or one special character (E.g. , . _ & ? etc)';
    } else if (value !== target) {
      return 'Password confirmation does not match';
    }
    return true;
  }
});

extend('text', {
  params: ['target'],
  validate: (value: string) => {
    if (!customerInputRegExp.test(value)) {
      return invalidTextMsg;
    }
    return true;
  }
});

extend('nameField', {
  validate: (value) => /^[A-Za-zÄÖÜäöüß\s.'-]+$/u.test(value),
  message: 'Invalid characters used'
});

export default defineComponent({
  name: 'RegisterJoinClub',
  components: {
    Input,
    SfButton,
    Checkbox,
    SfLoader,
    ValidationObserver,
    ValidationProvider,
    AddressNew,
    Select,
    SfLink,
    SfCheckbox,
    LoaderFrame
  },
  props: {
    form: {
      type: Object as PropType<RegisterFormFieldsClub>,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showRecaptcha: {
      type: Boolean,
      default: false,
    },
    selectors: {
      type: Object,
      required: false,
    }
  },

  setup(props, {emit}) {
    const {sendMessage} = useNotifications();
    const {getPageUrl} = useUrl();
    const {$vsf, $config} = useContext();
    const formCopy = ref<RegisterFormFieldsClub>();
    watch(() => props.form, (newForm) => {
      formCopy.value = {...newForm};
    }, {immediate: true, deep: true});
    const changeForm = (formToNavigateTo: FormName) => {
      emit('change-form', formToNavigateTo);
    };
    const {search: searchCountry} = useCountrySearch();
    const {load: loadCountries} = useCountrySearch();
    const country = ref<Country | null>(null);
    const countries = ref<Country[]>([]);

    const {fetch} = useFetch(async () => {
      const [countriesResponse] = await Promise.all([loadCountries({scope: 'register/club'})]);
      countries.value = countriesResponse;
    });

    const countriesList = computed(() => addressGetter.countriesList(countries.value));

    const changeCountry = async (id: string) => {
      country.value = await searchCountry({id});
      formCopy.value.sf_country_id = id;
    };

    const sortedCountries = computed(() =>
        [...countriesList.value].sort((a, b) => {
          if (a.id === 'AT') return -1;
          if (b.id === 'AT') return 1;
          if (a.id === 'DE') return -1;
          if (b.id === 'DE') return 1;
          return 0;
        })
    );

    const transformSelectors = (data: any): Record<string, any[]> => {
      const result: Record<string, any[]> = {};

      if (data) {
        data.forEach(item => {
          if (item.attribute_code) {
            result[item.attribute_code] = item.options.map(option => ({
              ...option,
              attribute_code: item.attribute_code
            }));
          }
        });
      }

      return result;
    };

    const submitRegistrationForm = async function (formData) {
      const variables = {input: formData};
      const {status, message, errors} = (await $vsf.$magento.api.customMutation({
        mutation: createCustomerSF,
        mutationVariables: {...variables}
      }))?.data?.['clubRegistrationSalesforce'];

      return {status, message, errors};
    };


    const transformedSelectors = transformSelectors(props.selectors.options);

    const customLoad = ref(false);

    return {
      submitRegistrationForm,
      sortedCountries,
      transformedSelectors,
      changeCountry,
      countriesList,
      fetch,
      formCopy,
      changeForm,
      getPageUrl,
      sendMessage,
      customLoad
    };
  },
  methods: {
    getCountry(val) {
      if (!this.countriesList.length || !val) return {label: '', abbreviation: ''};
      return this.countriesList.find((country) => country.id == val);
    },
    changeSelector(option, value) {
      return this.formCopy[option] = value;
    },
    getSelection(attributeCode: string, val: any) {
      const options = this.transformedSelectors[attributeCode];
      if (!options || !options.length || !val) return {label: '', value: ''};

      return options.find(option => option.value === val);
    },
    async handleSubmitForm() {
      this.customLoad = true;

      const formData = {
        ...this.formCopy,
        firstname: this.formCopy['firstName'],
        lastname: this.formCopy['lastName'],
        is_subscribed: this.formCopy['shouldSubscribeToNewsletter'],
        sf_registration_type: 'club',
        sf_is_online_customer: this.formCopy['sf_is_online_customer'].toString()
      }; // or format it as needed

      delete formData['privacyPolicy'];
      delete formData['shouldSubscribeToNewsletter'];
      delete formData['passwordConfirm'];
      delete formData['lastName'];
      delete formData['firstName'];
      delete formData['gender'];

      try {
        const {status, message, errors} = await this.submitRegistrationForm(formData);

        if(status && message) {
          this.sendMessage('Registration successful', message, false);
          await this.$router.push(this.getPageUrl('/'));
        }else if(errors) {
          this.sendMessage('Errors during the registration', message ? message : this.$t('Errors during the registration'));
        }
      } catch (e) {
        this.sendMessage('Errors during the registration', this.$t('Errors during the registration'));
      } finally {
        this.customLoad = false;
      }
    },
  }
});

